import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'

import { FB_PAGE_OPTION } from '../../../../../forms/Facebook/AdForms/fields'

import { accessibleSocialPagesSelector } from '../../../../../modules/selectors/socialAccounts'

import useStyles from './styles'

function PageName({ elementInProgress, pageId, sponsorPageId }) {
  const { t } = useTranslation()
  const classes = useStyles()

  const facebookPages = useSelector(accessibleSocialPagesSelector)

  const page = facebookPages.find(page => page['external_id'] && page['external_id'] === pageId)
  const sponsorPage = facebookPages.find(page => page['external_id'] && page['external_id'] === sponsorPageId)

  const pageName = page?.name
  const sponsorPageName = sponsorPage?.name

  const pageNameInProgress = elementInProgress === FB_PAGE_OPTION

  if (sponsorPageName) {
    return (
      <>
        <span className={classes.pageName}>{pageName} </span>
        {t('with')}
        <span className={classes.pageName}> {sponsorPageName}</span>
      </>
    )
  } else if (pageName) {
    return <span className={classes.pageName}>{pageName}</span>
  } else {
    return <PreviewTextFieldSkeleton isInProgress={pageNameInProgress} count={1} className={classes.skeletonPageName} />
  }
}

PageName.propTypes = {
  elementInProgress: PropTypes.string,
  pageId: PropTypes.string,
  sponsorPageId: PropTypes.string
}

export default PageName
